import React, { useEffect, useState } from "react";
import {
  Header,
  Container,
  Label,
  Form,
  Button,
  Grid,
  Icon,
} from "semantic-ui-react";
import {
  FASE_APERTURA_CUENTA_AHORROS_INICIAL,
  FASE_APERTURA_CUENTA_AHORROS_CONFIRMACION,
  FASE_APERTURA_CUENTA_AHORROS_COMPLETADO,
  LABEL_HE_LEIDO_DOCUMENTOS_CONTRACTUALES_APERTURA_CUENTA,
  MSG_VALIDATE_ACEPTAR_CLAUSULAS_CONTRACTUALES,
  NOMBRE_TIPO_CUENTA_AHORROS,
  RESPONSE_MESSAGE_CODE_SUCCESS,
  LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR,
  LABEL_CONFIRMAR_OPERACION_CLAVE_DOBLE_FACTOR,
  LABEL_INGRESE_CLAVE_DOBLE_FACTOR,
  MESSAGE_VALIDACION_CLAVE_DOBLE_FACTOR,
  CODIGO_TIPO_CUENTA_PASIVO_AHORROS,
  LONGITUD_MAXIMA_IMPORTE,
  SALDO_MINIMO_APERTURA_CUENTA_CARGO,
  CODIGO_TIPO_PROCESO_AUDITORIA_APERTURA_CUENTA_AHORROS,
} from "../../../../app/infrastructure/appConstants";
import AperturarCuentaAhorrosHeader from "./AperturarCuentaAhorrosHeader";
import { tipoMonedaOptions } from "../../../../app/config/data/options";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  aperturarCuentaAhorrosValidar,
  aperturarCuentaAhorrosConfirmar,
  getCuentasOperaciones,
  getProductosCuentaApertura,
} from "../../../../app/store/actions/cuentaActions";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { Form as FinalForm, Field } from "react-final-form";
import CheckboxInput from "../../../../app/common/form/CheckboxInput";
import ErrorMessage from "../../../../app/common/form/ErrorMessage";
import {
  combineValidators,
  composeValidators,
  isRequired,
  isOneOf,
  hasLengthBetween,
} from "revalidate";
import { Link } from "react-router-dom";
import AperturarCuentaAhorrosResumen from "./AperturarCuentaAhorrosResumen";
import { verificarDisponibilidadPago } from "../../../../app/store/actions/pagoActions";
import {
  generarClaveDobleFactor,
  validarClaveDobleFactor,
} from "../../../../app/store/actions/transactionalActions";
import { toast } from "react-toastify";
import ModalClaveDobleFactor from "../../../../app/common/modals/ModalClaveDobleFactor";
import { normalizeNumero } from "../../../../app/util/finalFormUtils";
import TextInput from "../../../../app/common/form/TextInput";
import DisponibilidadOperaciones from "../../../../app/common/messages/DisponibilidadOperacionesMessage";
import ListaDocumentosContractuales from "../common/ListaDocumentosContractuales";
import { resetScroll } from "../../../../app/util/JsUtils";
import {
  MESSAGE_CLAVE_DOBLE_FACTOR_NO_VALIDA,
  TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL,
} from "../../../../app/util/messageUtils";
import {
  createOptionsCuentaAperturarCargo,
  createOptionsProductosCuenta,
} from "../../../../app/util/optionsUtils";
import {
  getUrlDocumentoCartilla,
  getUrlDocumentoContrato,
} from "../../../../app/util/cuentaUtils";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import NumberInput from "../../../../app/common/form/NumberInput";
import isRequiredIf from "revalidate/lib/validators/isRequiredIf";
import { getDescripcionMoneda } from "../../../../app/util/textCodeUtils";
import { isGreaterThanOrEqualConditional } from "../../../../app/util/revalidateUtils";
import {
  buildGenerarClaveDobleFactorRequest,
  buildValidarClaveDobleFactorRequest,
} from "../../../../app/util/transactionalUtils";

const actions = {
  aperturarCuentaAhorrosValidar,
  aperturarCuentaAhorrosConfirmar,
  getCuentasOperaciones,
  verificarDisponibilidadPago,
  generarClaveDobleFactor,
  validarClaveDobleFactor,
  getProductosCuentaApertura,
};

const mapState = (state) => ({
  loadingAperturarCuentaAhorroValidar:
    state.cuentaReducer.loadingAperturarCuentaAhorroValidar,
  loadingAperturarCuentaAhorroConfirmar:
    state.cuentaReducer.loadingAperturarCuentaAhorroConfirmar,
  loadingDisponibilidadPago: state.pagoReducer.loadingDisponibilidadPago,
  loadingGenerarClaveDobleFactor:
    state.transactionalReducer.loadingGenerarClaveDobleFactor,
  loadingValidarClaveDobleFactor:
    state.transactionalReducer.loadingValidarClaveDobleFactor,
  claveDobleFactorUsuario: state.transactionalReducer.claveDobleFactorUsuario,
  getProductosCuentaApertura: state.cuentaReducer.getProductosCuentaApertura,
  productosCuenta: state.cuentaReducer.productosCuenta,
  loadingProductosCuentaApertura:
    state.cuentaReducer.loadingProductosCuentaApertura,
  currentUser: state.auth.currentUser,
  loadingCuentasOperaciones: state.cuentaReducer.loadingCuentasOperaciones,
  cuentasOperaciones: state.cuentaReducer.cuentasOperaciones,
});

const AperturarCuentaAhorrosPage = ({
  aperturarCuentaAhorrosValidar,
  loadingAperturarCuentaAhorroValidar,
  aperturarCuentaAhorrosConfirmar,
  loadingAperturarCuentaAhorroConfirmar,
  verificarDisponibilidadPago,
  loadingDisponibilidadPago,
  generarClaveDobleFactor,
  validarClaveDobleFactor,
  loadingGenerarClaveDobleFactor,
  loadingValidarClaveDobleFactor,
  claveDobleFactorUsuario,
  getProductosCuentaApertura,
  productosCuenta,
  loadingProductosCuentaApertura,
  currentUser,
  getCuentasOperaciones,
  loadingCuentasOperaciones,
  cuentasOperaciones,
}) => {
  //Constantes
  console.log("page", claveDobleFactorUsuario);
  const generarClaveDobleFactorRequest = buildGenerarClaveDobleFactorRequest(
    CODIGO_TIPO_PROCESO_AUDITORIA_APERTURA_CUENTA_AHORROS,
    claveDobleFactorUsuario
  );

  //hook effect
  useEffect(() => {
    if(currentUser){
      getCuentasOperaciones();
    }
  }, [getCuentasOperaciones, currentUser?.username]);

  //states
  const [faseAperturaCuenta, setFaseAperturaCuenta] = useState(
    FASE_APERTURA_CUENTA_AHORROS_INICIAL
  );
  const [codigoMoneda, setCodigoMoneda] = useState(null);
  const [tasaInteres, setTasaInteres] = useState(null);
  const [numeroCuentaCreada, setNumeroCuentaCreada] = useState(null);
  const [claveDobleFactor, setClaveDobleFactor] = useState(null);
  const [
    indicadorAceptacionTerminos,
    setIndicadorAceptacionTerminos,
  ] = useState(false);
  const [
    flagGeneracionExitosaClaveDobleFactor,
    setGeneracionExitosaClaveDobleFactor,
  ] = useState(false);
  const [
    msgValidacionClaveDobleFactor,
    setMsgValidacionClaveDobleFactor,
  ] = useState(null);
  const [
    openModalGenerarClaveDobleFactor,
    setOpenModalGenerarClaveDobleFactor,
  ] = useState(false);
  const [productoCuenta, setProductoCuenta] = useState(null);
  const [productosCuentaOptions, setProductosCuentaOptions] = useState([]);
  const [cuentaCargo, setCuentaCargo] = useState(null);
  const [codigoMonedaCuentaOrigen, setCodigoMonedaCuentaOrigen] = useState(
    null
  );
  const [importeApertura, setImporteApertura] = useState(null);
  const [saldoMinimo, setSaldoMinimo] = useState(null);
  const [tipoCambioValidado, setTipoCambioValidado] = useState(null);
  const [aplicaTipoCambio, setAplicaTipoCambio] = useState(false);
  const [importeDebitarValidado, setImporteDebitarValidado] = useState(null);
  const [monedaDebitarValidado, setMonedaDebitarValidado] = useState(null);
  const [aplicaCuentaCargo, setAplicaCuentaCargo] = useState(false);

  //effects
  useEffect(() => {
    if(currentUser){
      getProductosCuentaApertura({
        tipoCuenta: CODIGO_TIPO_CUENTA_PASIVO_AHORROS,
        codigoMoneda: "%",
        tipoPersona: currentUser.tipoPersona,
      });
    }
  }, [getProductosCuentaApertura, currentUser?.tipoPersona]);

  //Business
  const validarAperturaCuenta = async () => {
    const response = await verificarDisponibilidadPago();
    if (response && response.data && response.data.disponible === true) {
      const validarAperturaResponse = await aperturarCuentaAhorrosValidar({
        codigoProducto: productoCuenta,
        saldoInicial: importeApertura,
        cuentaCargo: cuentaCargo,
      });
      if (validarAperturaResponse && validarAperturaResponse.tasa) {
        try {
          //Generando clave doble factor
          const response = await generarClaveDobleFactor(
            generarClaveDobleFactorRequest
          );
          //end
          if (response && response.code === RESPONSE_MESSAGE_CODE_SUCCESS) {
            setGeneracionExitosaClaveDobleFactor(true);
            setFaseAperturaCuenta(FASE_APERTURA_CUENTA_AHORROS_CONFIRMACION);
            setTasaInteres(validarAperturaResponse.tasa);
            setTipoCambioValidado(validarAperturaResponse.tipoCambio);
            setAplicaTipoCambio(
              codigoMonedaCuentaOrigen &&
                codigoMonedaCuentaOrigen !== codigoMoneda
            );
            setMonedaDebitarValidado(validarAperturaResponse.monedaRetiro);
            setImporteDebitarValidado(validarAperturaResponse.importeRetiro);
            resetScroll();
          }
        } catch (error) {
          if (error && error.data && error.data.status !== 401) {
            toast.error(error.data.message);
          }
        }
      }
    }
  };

  const atrasAperturaCuenta = () => {
    setFaseAperturaCuenta(FASE_APERTURA_CUENTA_AHORROS_INICIAL);
    setTasaInteres(null);
    setClaveDobleFactor(null);
  };

  const handleConfirmarAperturaCuenta = async (values) => {
    //Validando Clave Doble Factor
    let responseValidacionClaveDobleFactor;
    try {
      responseValidacionClaveDobleFactor = await validarClaveDobleFactor(
        buildValidarClaveDobleFactorRequest(
          claveDobleFactorUsuario,
          claveDobleFactor
        )
      );
    } catch (error) {
      const msgValidacion = error.data.message;
      setMsgValidacionClaveDobleFactor(msgValidacion);
      setGeneracionExitosaClaveDobleFactor(false);
      setOpenModalGenerarClaveDobleFactor(true);
      setClaveDobleFactor(null);
    }
    //end
    if (
      responseValidacionClaveDobleFactor &&
      responseValidacionClaveDobleFactor.code === RESPONSE_MESSAGE_CODE_SUCCESS
    ) {
      const confirmarAperturaResponse = await aperturarCuentaAhorrosConfirmar({
        aceptoClausulas: indicadorAceptacionTerminos,
        codigoProducto: productoCuenta,
        saldoInicial: importeApertura,
        cuentaCargo: cuentaCargo,
      });
      if (confirmarAperturaResponse && confirmarAperturaResponse.numeroCuenta) {
        setFaseAperturaCuenta(FASE_APERTURA_CUENTA_AHORROS_COMPLETADO);
        setNumeroCuentaCreada(confirmarAperturaResponse.numeroCuenta);
        resetScroll();
      }
    }
  };

  //validate
  const validate = combineValidators({
    indicadorAceptacionTerminos: composeValidators(
      isRequired({
        message: MSG_VALIDATE_ACEPTAR_CLAUSULAS_CONTRACTUALES,
      }),
      isOneOf([true])
    )({ message: MSG_VALIDATE_ACEPTAR_CLAUSULAS_CONTRACTUALES }),
    claveDobleFactor: composeValidators(
      isRequired({ message: MESSAGE_VALIDACION_CLAVE_DOBLE_FACTOR }),
      hasLengthBetween(
        LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR,
        LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR
      )({
        message: MESSAGE_CLAVE_DOBLE_FACTOR_NO_VALIDA,
      })
    )(),
  });

  const validateValidarApertura = combineValidators({
    tipoMoneda: composeValidators(
      isRequired({ message: "Debe seleccionar una moneda" })
    )(),
    productoCuenta: composeValidators(
      isRequired({ message: "Debe seleccionar el tipo de cuenta" })
    )(),
    importeApertura: composeValidators(
      isRequiredIf(
        (values) => values && values.productoCuenta && aplicaCuentaCargo
      )({
        message: "Debe ingresar un importe para poder aperturar la cuenta.",
      }),
      isGreaterThanOrEqualConditional(
        saldoMinimo,
        aplicaCuentaCargo
      )({
        message: `Debe ingresar al menos un importe de ${saldoMinimo} ${getDescripcionMoneda(
          codigoMoneda
        )}.`,
      })
    )(),
    cuentaCargo: composeValidators(
      isRequiredIf(
        (values) => values && values.productoCuenta && aplicaCuentaCargo
      )({
        message: "Debe seleccionar la cuenta de cargo.",
      })
    )(),
  });
  //Options
  const cuentasOptions = createOptionsCuentaAperturarCargo(cuentasOperaciones);

  //loadings
  if (loadingAperturarCuentaAhorroValidar)
    return <LoadingComponent content="Validando apertura de cuenta..." />;
  if (loadingAperturarCuentaAhorroConfirmar)
    return <LoadingComponent content="Creando cuenta..." />;
  if (loadingDisponibilidadPago)
    return <LoadingComponent content="Consultando disponibilidad de pago..." />;
  if (loadingGenerarClaveDobleFactor)
    return <LoadingComponent content="Generar Clave..." />;
  if (loadingValidarClaveDobleFactor)
    return <LoadingComponent content="Validar Clave..." />;
  if (loadingProductosCuentaApertura)
    return <LoadingComponent content="Listar Producto Cuentas..." />;
  if (loadingCuentasOperaciones)
    return <LoadingComponent content="Cargando cuentas operaciones..." />;
  return (
    <>
      <Container className="containerPrincipal">
        {faseAperturaCuenta === FASE_APERTURA_CUENTA_AHORROS_INICIAL ? (
          <>
            <AperturarCuentaAhorrosHeader />
            <div style={{ marginTop: "2.5em" }}>
              <Header as="h4" color="blue" content="Tipo de cuenta" />

              <Label color="blue" tag size="large">
                {NOMBRE_TIPO_CUENTA_AHORROS}
              </Label>

              <FinalForm
                onSubmit={(values) => {
                  validarAperturaCuenta(values);
                }}
                initialValues={{
                  tipoMoneda: codigoMoneda,
                  productoCuenta: productoCuenta,
                  cuentaCargo: cuentaCargo,
                  importeApertura: importeApertura,
                }}
                validate={validateValidarApertura}
                render={({
                  handleSubmit,
                  submitting,
                  submitError,
                  invalid,
                  pristine,
                  dirtySinceLastSubmit,
                  values,
                }) => (
                  <Form
                    onSubmit={handleSubmit}
                    error
                    style={{ marginTop: "2.5em" }}
                  >
                    <Header
                      as="h4"
                      color="blue"
                      content="Selecciona la moneda"
                    />
                    <Field
                      name="tipoMoneda"
                      placeholder="Selecciona la moneda"
                      fluid
                      component={SelectedInput}
                      options={tipoMonedaOptions}
                      handleOnChange={(value) => {
                        setCodigoMoneda(value);
                        setProductoCuenta(null);
                        setProductosCuentaOptions(
                          createOptionsProductosCuenta(
                            productosCuenta,
                            value,
                            currentUser?.tipoPersona
                          )
                        );
                      }}
                      value={codigoMoneda}
                    />
                    <Header
                      as="h4"
                      color="blue"
                      content="Selecciona el tipo de cuenta"
                    />
                    <Field
                      name="productoCuenta"
                      placeholder="Selecciona el tipo de cuenta"
                      disabled={!codigoMoneda}
                      component={SelectedInput}
                      fluid
                      options={productosCuentaOptions}
                      handleOnChange={(value) => {
                        setProductoCuenta(value);
                        if (
                          value &&
                          productosCuenta &&
                          productosCuenta.length > 0
                        ) {
                          const productoCuenta = productosCuenta.filter(
                            (c) => c.producto === value
                          )[0];
                          setAplicaCuentaCargo(
                            productoCuenta.saldoMinimo >
                              SALDO_MINIMO_APERTURA_CUENTA_CARGO
                          );
                          setSaldoMinimo(productoCuenta.saldoMinimo);
                        }
                        setImporteApertura(null);
                        setCuentaCargo(null);
                        setAplicaTipoCambio(false);
                        setCodigoMonedaCuentaOrigen(null);
                      }}
                      value={productoCuenta}
                    />

                    {productoCuenta && saldoMinimo && aplicaCuentaCargo && (
                      <>
                        <Header
                          as="h4"
                          color="blue"
                          content="Ingresa el importe de apertura"
                        />
                        <Field
                          name="importeApertura"
                          component={NumberInput}
                          placeholder="Ingresa el importe de apertura"
                          handleOnChange={(value) => {
                            setImporteApertura(value);
                          }}
                          disabled={!codigoMoneda}
                          maxLength={LONGITUD_MAXIMA_IMPORTE}
                        />

                        <Header
                          as="h4"
                          color="blue"
                          content="Selecciona la cuenta cargo"
                        />
                        <Field
                          name="cuentaCargo"
                          component={SelectedInput}
                          placeholder="Selecciona la cuenta cargo"
                          options={cuentasOptions}
                          handleOnChange={(value) => {
                            setCuentaCargo(value);
                            if (
                              value &&
                              cuentasOperaciones &&
                              cuentasOperaciones.length > 0
                            ) {
                              const cuenta = cuentasOperaciones.filter(
                                (c) => c.numeroCuenta === value
                              )[0];
                              setCodigoMonedaCuentaOrigen(cuenta.codigoMoneda);
                            }
                          }}
                        />
                      </>
                    )}

                    {codigoMonedaCuentaOrigen &&
                      codigoMoneda &&
                      codigoMonedaCuentaOrigen !== codigoMoneda && (
                        <Label color="blue" tag size="medium">
                          {TRANSFERENCIA_SUJETA_TIPO_CAMBIO_ACTUAL}
                        </Label>
                      )}
                    <br />
                    <br />
                    <Container textAlign="center">
                      <Button
                        disabled={invalid}
                        size="large"
                        color="yellow"
                        content="Siguiente"
                        style={{ minWidth: "12em", maxWidth: "15em" }}
                        loading={submitting}
                      />
                    </Container>
                  </Form>
                )}
              />
            </div>
          </>
        ) : faseAperturaCuenta === FASE_APERTURA_CUENTA_AHORROS_CONFIRMACION ? (
          <>
            {tasaInteres && (
              <>
                <AperturarCuentaAhorrosHeader />
                <DisponibilidadOperaciones />
                <div style={{ marginTop: "2.5em" }}>
                  <Header
                    as="h4"
                    color="blue"
                    content="Confirmación de apertura de cuenta"
                  />
                  <AperturarCuentaAhorrosResumen
                    codigoMoneda={codigoMoneda}
                    tasaInteres={tasaInteres}
                    importe={importeApertura}
                    cuentaCargo={cuentaCargo}
                    aplicaTipoCambio={aplicaTipoCambio}
                    tipoCambio={tipoCambioValidado}
                    importeDebitarValidado={importeDebitarValidado}
                    monedaDebitarValidado={monedaDebitarValidado}
                    aplicaCuentaCargo={aplicaCuentaCargo}
                  />
                  <br />
                  <FinalForm
                    onSubmit={(values) => {
                      handleConfirmarAperturaCuenta(values);
                    }}
                    validate={validate}
                    initialValues={{
                      indicadorAceptacionTerminos: indicadorAceptacionTerminos,
                      claveDobleFactor: claveDobleFactor,
                    }}
                    render={({
                      handleSubmit,
                      submitting,
                      submitError,
                      invalid,
                      pristine,
                      dirtySinceLastSubmit,
                      values,
                    }) => (
                      <Form onSubmit={handleSubmit} error>
                        {submitError && !dirtySinceLastSubmit && (
                          <ErrorMessage error={submitError} />
                        )}
                        <ListaDocumentosContractuales
                          urlDocumentoContrato={getUrlDocumentoContrato(
                            productosCuenta,
                            productoCuenta
                          )}
                          urlDocumentoPlantilla={getUrlDocumentoCartilla(
                            productosCuenta,
                            productoCuenta
                          )}
                        />
                        <br />
                        <Field
                          name="indicadorAceptacionTerminos"
                          component={CheckboxInput}
                          type="checkbox"
                          label={
                            LABEL_HE_LEIDO_DOCUMENTOS_CONTRACTUALES_APERTURA_CUENTA
                          }
                          handleOnChange={(value) => {
                            setIndicadorAceptacionTerminos(value);
                          }}
                          checked={indicadorAceptacionTerminos}
                        />
                        <Header
                          as="h4"
                          color="blue"
                          content={LABEL_CONFIRMAR_OPERACION_CLAVE_DOBLE_FACTOR}
                          textAlign="left"
                        />
                        <Field
                          name="claveDobleFactor"
                          component={TextInput}
                          placeholder={LABEL_INGRESE_CLAVE_DOBLE_FACTOR}
                          maxLength={LONGITUD_MAXIMA_ClAVE_DOBLE_FACTOR}
                          parse={normalizeNumero}
                          handleOnChange={(value) => {
                            setClaveDobleFactor(normalizeNumero(value));
                          }}
                        />
                        <br />
                        <Grid>
                          <Grid.Row>
                            <Grid.Column
                              computer={4}
                              largeScreen={4}
                              mobile={7}
                              tablet={6}
                            >
                              <Button
                                fluid
                                content="Atrás"
                                color="blue"
                                size="large"
                                onClick={(e) => {
                                  e.preventDefault();
                                  atrasAperturaCuenta();
                                }}
                              />
                            </Grid.Column>
                            <Grid.Column
                              computer={8}
                              largeScreen={8}
                              mobile={2}
                              tablet={4}
                            />
                            <Grid.Column
                              computer={4}
                              largeScreen={4}
                              mobile={7}
                              tablet={6}
                            >
                              <Button
                                content="Confirmar"
                                disabled={
                                  invalid &&
                                  flagGeneracionExitosaClaveDobleFactor
                                }
                                loading={submitting}
                                fluid
                                color="yellow"
                                size="large"
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Form>
                    )}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <>
            <Container style={{ width: "65%" }} textAlign="center">
              <br />
              <Icon name="check circle outline" color="yellow" size="huge" />
              <Header as="h1" color="blue" size="huge">
                Se creó tu cuenta con éxito
              </Header>
              <Header as="h4" color="blue" size="tiny">
                Te enviamos un correo con el detalle de la apertura de tu
                cuenta.
              </Header>
              <AperturarCuentaAhorrosResumen
                codigoMoneda={codigoMoneda}
                tasaInteres={tasaInteres}
                importe={importeApertura}
                cuentaCargo={cuentaCargo}
                numeroCuenta={numeroCuentaCreada}
                aplicaTipoCambio={aplicaTipoCambio}
                tipoCambio={tipoCambioValidado}
                importeDebitarValidado={importeDebitarValidado}
                monedaDebitarValidado={monedaDebitarValidado}
                aplicaCuentaCargo={aplicaCuentaCargo}
              />
              <br />
              <Container textAlign="center">
                <Button
                  to="/cuentas"
                  as={Link}
                  color="yellow"
                  size="large"
                  content="Ir a mis cuentas"
                />
              </Container>
            </Container>
          </>
        )}
      </Container>
      <ModalClaveDobleFactor
        openModel={openModalGenerarClaveDobleFactor}
        generarClaveDobleFactorRequest={generarClaveDobleFactorRequest}
        msgValidacionClaveDobleFactor={msgValidacionClaveDobleFactor}
        setGeneracionExitosaClaveDobleFactor={
          setGeneracionExitosaClaveDobleFactor
        }
        setOpenModalGenerarClaveDobleFactor={
          setOpenModalGenerarClaveDobleFactor
        }
      />
    </>
  );
};

AperturarCuentaAhorrosPage.propTypes = {
  loadingAperturarCuentaAhorroValidar: PropTypes.bool.isRequired,
  aperturarCuentaAhorrosValidar: PropTypes.func.isRequired,
  loadingAperturarCuentaAhorroConfirmar: PropTypes.bool.isRequired,
  verificarDisponibilidadPago: PropTypes.func.isRequired,
  loadingDisponibilidadPago: PropTypes.bool.isRequired,
  generarClaveDobleFactor: PropTypes.func.isRequired,
  validarClaveDobleFactor: PropTypes.func.isRequired,
  claveDobleFactorUsuario: PropTypes.object,
  loadingGenerarClaveDobleFactor: PropTypes.bool.isRequired,
  loadingValidarClaveDobleFactor: PropTypes.bool.isRequired,
  getProductosCuentaApertura: PropTypes.func.isRequired,
  productosCuenta: PropTypes.array.isRequired,
  loadingProductosCuentaApertura: PropTypes.bool.isRequired,
  currentUser: PropTypes.object.isRequired,
  cuentasOperaciones: PropTypes.array.isRequired,
  getCuentasOperaciones: PropTypes.func.isRequired,
  loadingCuentasOperaciones: PropTypes.bool.isRequired,
};

export default connect(mapState, actions)(AperturarCuentaAhorrosPage);
